
import React from 'react';
import type { User, Language } from '../types';
import XIcon from './icons/XIcon';
import UsersIcon from './icons/UsersIcon';
import { getTranslation } from '../utils/translations';

interface RecipeOwnerInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    owner: User | undefined;
    language?: Language;
}

const RecipeOwnerInfoModal: React.FC<RecipeOwnerInfoModalProps> = ({ isOpen, onClose, owner, language }) => {
    const t = (key: any) => getTranslation(language, key);

    if (!isOpen) return null;

    const displayName = owner 
        ? (owner.nickname || `${owner.firstName || ''} ${owner.lastName || ''}`.trim() || owner.email)
        : t('unknownUser');

    return (
        <div className="fixed inset-0 bg-black/20 flex items-center justify-center z-[60] p-4" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-xl w-full max-w-xs p-5 border border-slate-100 relative animate-fade-in" onClick={e => e.stopPropagation()}>
                <div className="absolute top-2 left-2">
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
                        <XIcon className="w-5 h-5" />
                    </button>
                </div>
                
                <div className="flex flex-col items-center text-center">
                    <div className="bg-sky-100 p-3 rounded-full mb-3 text-sky-600">
                        <UsersIcon className="w-8 h-8" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-800 mb-1">{t('recipeOwner')}</h3>
                    <p className="text-lg font-medium text-sky-700">{displayName}</p>
                    {owner && (
                        <p className="text-xs text-slate-400 mt-1">{owner.email}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecipeOwnerInfoModal;
